import NewsletterImage from "@assets/images/newsletter-pic.webp";
import SuccessImg from "@assets/images/success.webp";
import { NEWSLETTER_MESSAGES } from "@config/NewsletterFormConstants";
import { SocialMedia } from "@header/TopHeader/TopSocialMedia";
import fetchTMApi from "@helper/fetchTMApi";
import { getValidEmailRegex } from "@helper/utils";
import { NewsletterPostResponse } from "@typings/Newsletter";
import type { ReactElement } from "react";
import { FormEvent, useState } from "react";

type Props = Readonly<{
  testId?: string;
}>;
export default function UnsubscribeForm({
  testId = "newsletter-form",
}: Props): ReactElement {
  const [email, setEmail] = useState<string>("");
  const [errorMsg, setErrorMsg] = useState<string>("");
  const [successMsg, setSuccessMsg] = useState<string>("");

  async function handleOnSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    e.stopPropagation();
    // validate email
    if (
      email &&
      getValidEmailRegex().test(email) // Valid email format
    ) {
      try {
        const res = await fetchTMApi("newsletterUnSubscribe", "POST", {
          email,
        });
        const data = (await res) as NewsletterPostResponse;
        if (data.msg) {
          setErrorMsg(""); // unset error message
          setSuccessMsg(data.msg);
          return;
        }

        if (data.errorMsg) {
          setErrorMsg(data.errorMsg);
          return;
        }
      } catch (e: unknown) {
        setErrorMsg(NEWSLETTER_MESSAGES.FAILED);
        return;
      }
    } else {
      // Invalid email
      setErrorMsg(NEWSLETTER_MESSAGES.INVALID_EMAIL);
      return;
    }
  }

  function handleInputChange(e: React.ChangeEvent<HTMLInputElement>) {
    setEmail(e.target.value);
  }

  return (
    <>
      {successMsg ? (
        <div className="flex flex-col items-center gap-6 mt-6">
          <div className="w-full py-6 bg-green-250 border-t-2 border-green-550">
            <div className="flex flex-col items-center gap-2">
              <div>
                <img src={SuccessImg} alt="success" width={52} />
              </div>
              <div className="w-[250px] text-center text-gray-100 text-md leading-[135%] font-semibold">
                {successMsg}
              </div>
            </div>
          </div>
          <div className="flex flex-col items-center gap-2">
            <div className="text-gray-100 text-2sm leading-[150%]">
              எங்களை தொடர மற்ற சில வழிகள் இங்கே
            </div>
            <div>
              <SocialMedia testId={testId} />
            </div>
          </div>
        </div>
      ) : (
        <>
          <div>
            <img src={NewsletterImage} width={150} alt="newsletter" />
          </div>
          <div className="w-full pt-sm">
            <div className="">
              <h3 className="text-gray-100 text-2.5md font-bold">ரத்துசெய்</h3>
              <form
                onSubmit={(e: FormEvent<HTMLFormElement>) =>
                  void handleOnSubmit(e)
                }
                data-testid={testId}
                className="flex flex-col gap-[5px] sm:flex-row sm:gap-0 mt-2"
              >
                <div className="flex-1">
                  <input
                    id="unsubscribe-email"
                    name="unsub-email"
                    onChange={handleInputChange}
                    type="email"
                    className="block w-full h-9 py-1.5 px-3 text-xs font-normal leading-800 text-gray-1000 bg-white bg-clip-padding border border-solid border-gray-900 rounded transition ease-in-out duration-150 delay-0 focus:outline-none focus:border-pink-400 focus:shadow-5xl"
                    placeholder="மின்னஞ்சல் முகவரி"
                    required={true}
                    maxLength={254}
                    size={60}
                  />
                  {errorMsg && (
                    <div className="sm:hidden text-red-850 text-xs leading-[160%]">
                      {errorMsg}
                    </div>
                  )}
                </div>
                <button
                  className="w-full sm:w-[93px] align-middle select-none py-1.5 px-3 text-xs leading-800 rounded transition ease-in-out duration-150 delay-0 border-0 text-white-100 bg-100 relative"
                  aria-label="Unsubscribe from Newsletter"
                >
                  அனுப்பு
                </button>
              </form>
            </div>
          </div>
          {errorMsg && (
            <div className="hidden sm:block text-red-850 text-xs leading-[160%]">
              {errorMsg}
            </div>
          )}
        </>
      )}
    </>
  );
}
